module.exports = __webpack_public_path__ + "img/20200906_162128.cee83d4f.jpg";